import { render } from "./qzjjiancedetail.vue?vue&type=template&id=52aa9ca0&scoped=true&ts=true"
import script from "./qzjjiancedetail.vue?vue&type=script&lang=ts"
export * from "./qzjjiancedetail.vue?vue&type=script&lang=ts"

import "./qzjjiancedetail.vue?vue&type=style&index=0&id=52aa9ca0&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52aa9ca0"]])

export default __exports__